module.exports = __webpack_public_path__ + "static/media/chevron-up.a1347a00.svg";